export default __webpack_public_path__ + "static/media/foto06.85e73967.png";